// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__yy5v3","loaderOuter":"PageOverlayLoader_loaderOuter__2lN-U"};